import { SyncMethod } from './FamilyMember';

export const subsequentSync: SyncMethod = async replicationState => {
  replicationState.reSync();
  await replicationState.awaitInSync();
};
